module.exports = __webpack_public_path__ + "img/antes_despues_244.366058ac.png";